import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, serviceConstants, zipapiURL, formOptions } from '../constants/service.constants';
import { City, ZipResponse, ZipData, Menu, ModuleFeatureModel } from 'src/app/models/common';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { catchError, map, retry, switchMap, tap } from 'rxjs/operators';
import { IST_APP, EAP_APP, GM_APP } from 'src/app/models/common';
import { ModuleMenu } from 'src/app/models/common';
import { Organization } from 'src/app/models/um/organization';
import { SuccessBanertemplateComponent } from '../common/success-banertemplate/success-banertemplate.component';
import { ErrorbannerComponent } from '../common/errorbanner/errorbanner.component';
import { UserService } from './user.service';
import { MessageBoxComponent } from '../common/message-box/message-box.component';
import { DeleteBoxComponent } from '../common/delete-box/delete-box.component';
import { ConfirmationBoxComponent } from '../common/confirmation-box/confirmation-box.component';
import { IstSummaryService } from './ist/ist-summary.service';
import { HeadService } from './common/headservice';
import { Router } from '@angular/router';
import { IstDataShareService } from './ist/ist-datashare.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrantsDatashareService } from './grants/grants-datashare.service';
import { OnlineEditorComponentimplements } from '../common/online-editor/online-editor.component';
import { EditorType, UserEditConfig, UserEditorConfig } from '../constants/only-office-config';
import { AesEncriptionDecriptionService } from './common/aes-encription-decription.service';
import { ReviewService } from './common/review.service';
@Injectable({
  providedIn: 'root'
})

export class CommonService {

  zipresponse: ZipResponse;
  istapp: IST_APP;
  eapapp: EAP_APP;
  grantsapp: GM_APP;
  appId: string;
  ScreenID: string;
  leftmenus: Menu[] = [];
  topmenus: Menu[] = [];
  objcity: Observable<City>;
  menu: ModuleMenu;
  orgs: Organization[] = [];
  menudata: ModuleMenu;
  config:any= null;
  constructor(private http: HttpClient,
    private modalService: NgbModal,
    private userService: UserService,
    private summaryService: IstSummaryService,
    private header: HeadService,
    private router: Router, 
    private dataShare: IstDataShareService,
     private GrantsShare: GrantsDatashareService,
     private securityService:AesEncriptionDecriptionService
    ) {

  }

  isAutocodeConfigured(featureid: string, orgid: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/isautoconfigured/' + featureid + '/' + orgid, httpOptions)
  }
  activeFeature(table: string, id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/active/' + table + '/' + id, httpOptions)
  }

  inactiveFeature(table: string, id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/inactive/' + table + '/' + id, httpOptions)
  }

  checkMandatoryFormFileds(appid: string, action: string, module: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/common/checkmandatory/' + appid + '/' + action + '/' + module, formOptions)
  }

  updateMandatoryFormFileds(appid: string, action: string, module: string, featurecode: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/common/UpadteManadotory/' + appid + '/' + action + '/' + module + '/' + featurecode, httpOptions)
  }

  getMenu(model:ModuleFeatureModel): Observable<Menu[]> {
    return this.http.post<Menu[]>(serviceConstants.apiURL + 'api/common/getmodulefeatures', model, httpOptions)
  }


  getModulesList(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + "api/common/getmodules", httpOptions);
  }
  aplTypesList(moduleId:string): Observable<any> {debugger;
    return this.http.get(serviceConstants.apiURL + "api/apptypes/getallapp?moduleId=" + moduleId, httpOptions);
  }

  getAllApplicationTypes(moduleId:string, subModule: string): Observable<any> {;
    return this.http.get(serviceConstants.apiURL + "api/apptypes/getallapp/" + moduleId + '/' + subModule, httpOptions);
  }
  getAppTypesSpecificScreens(url:string): Observable<any> {;
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }
  getCity(zip: string): Observable<ZipResponse> {
    return this.http.get<ZipResponse>(serviceConstants.apiURL + 'api/common/getzipinfo/' + zip, httpOptions);

    ////let url = zipapiURL.replace("@zipcode@", zip);
    //let url = serviceConstants.apiURL + 'api/common/getzipinfo/' + zip;
    //return this.http.get<ZipResponse>(url).pipe(
    //  tap( // Check the Valid request
    //    data => {

    //    },
    //    error => {

    //    }
    //  )
    //);
  }


  getRegCity(zip: string): Observable<ZipResponse> {
    return this.http.get<ZipResponse>(serviceConstants.apiURL + 'api/appuser/getzipinfo/' + zip, httpOptions);
  }

getCurrentVersion(): Observable<any>{ //orgId:any
  return this.http.get(serviceConstants.apiURL + 'api/appuser/fetchiegbuildversion', httpOptions);
}

  getNotificationCount(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/Notifications/NotificationCount', httpOptions);
  }
  GetChangeLogInfo(appId: string, module_id: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getchangelogInfo/' + appId + "/" + module_id, httpOptions);
  }
  setModluleMenu(menu: ModuleMenu) {
    this.menu = menu;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(this.menu));
    localStorage.setItem('3AUBD6Gd6T_menu', encriptedStr);
  }

  getModuleMenu() {
    if (this.menu === null || this.menu === undefined) {
     let decriptedApp= this.securityService.decryptionAES(localStorage.getItem("3AUBD6Gd6T_menu"));
      this.menu = JSON.parse(decriptedApp);
    }
    return this.menu;
  }
  getModuleName() {
    let name = "";
    let menus =  this.getModuleMenu();
    if (menus != undefined && menus != null) {
      name = menus.module;
    }
    return name;

  }
  removeModuleMenu() {
    localStorage.setItem('3AUBD6Gd6T_menu', null);
    this.menu=null;
  }
 
  getEAPApp() {
    if (this.eapapp === null || this.eapapp === undefined) {
      this.eapapp = JSON.parse(localStorage.getItem("eapapp"));
    }
    return this.eapapp;
  }
  setEAPApp(app) {
    this.eapapp = app;
    localStorage.setItem('eapapp', JSON.stringify(app));
  }
  removeEAPApp() {
    this.eapapp = null;
    localStorage.setItem('eapapp', null);
  }

 

  getISTApp() {
    if (this.istapp === null || this.istapp === undefined) {
      let decriptedApp= this.securityService.decryptionAES(localStorage.getItem("ist_CPU10sfbxi_app"));
      this.istapp = JSON.parse(decriptedApp);
    }
    return this.istapp;
  }
  removeISTApp() {
    this.istapp = null;
    localStorage.setItem('it_CPU10sfbxi_app', null);
  }
  setISTApp(app) {
    this.istapp = app;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(this.istapp));
    localStorage.setItem('it_CPU10sfbxi_app', encriptedStr);
  }
 

  getIstStatus(): boolean {
    let IsSubmitRequired = false;
    this.istapp = this.getISTApp();
    IsSubmitRequired = this.istapp.STATUS == 1 ? false : true;
    return IsSubmitRequired;
  }

 
  setGrantsApp(app) {
    this.grantsapp = app;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(this.grantsapp));
    localStorage.setItem('grt_1ptM4xo4pX_app',encriptedStr);
  }
  removeGrantsApp() {
    this.grantsapp = null;
    localStorage.setItem('grt_1ptM4xo4pX_app', null);
  }
  getGrantsApp() {
    if (this.grantsapp === null || this.grantsapp === undefined) {
      let decriptedApp= this.securityService.decryptionAES(localStorage.getItem("grt_1ptM4xo4pX_app"));
      this.grantsapp = JSON.parse(JSON.stringify(decriptedApp));
    }
    return this.grantsapp;
  }
  getGrantsStatus(): number {
    this.grantsapp = this.getGrantsApp();
    return this.grantsapp.STATUS;
  }
  setLeftMenu(menus: Menu[]) {
    this.leftmenus = menus;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(this.leftmenus));
    localStorage.setItem("left_z9v2CpJ8qI",encriptedStr);
  }
  removeLeftMenu() {
    this.leftmenus = [];
    localStorage.setItem("left_z9v2CpJ8qI", null);
  }
  getLeftMenu() {
    if (this.leftmenus === null || this.leftmenus === undefined) {
      let decriptedApp= this.securityService.decryptionAES(localStorage.getItem("left_z9v2CpJ8qI"));
      this.leftmenus = JSON.parse(decriptedApp);
    }
    return this.leftmenus;
  }

  getPagePermission(pagecode: string) {
     ;
    let permission = "";
    if (this.leftmenus === null || this.leftmenus === undefined) {
      this.leftmenus =this.getLeftMenu();
    }

    if (this.leftmenus !== null && this.leftmenus !== undefined) {
      const len = this.leftmenus.length;
      for (let iCount = 0; iCount < len; iCount++) {
        if (this.leftmenus[iCount].Code == pagecode) {
          permission = this.leftmenus[iCount].Operation;
          break;
        }
      }
    }
    if (permission === "") {
      if (this.topmenus === null || this.topmenus === undefined) {
        this.topmenus = this.getTopMenu();
      }

      if (this.topmenus !== null && this.topmenus !== undefined) {
        const len = this.topmenus.length;
        for (let iCount = 0; iCount < len; iCount++) {
          if (this.topmenus[iCount].Code == pagecode) {
            permission = this.topmenus[iCount].Operation;
            break;
          }
        }
      }
    }
    return permission;
  }





  setTopMenu(menus: Menu[]) {
    this.topmenus = menus;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(this.topmenus))
    localStorage.setItem("top_Us4Kp7Thux_m", encriptedStr);
  }

  getTopMenu() {
    if (this.topmenus === null || this.topmenus === undefined) {
     let decriptedStr= this.securityService.decryptionAES(localStorage.getItem("top_Us4Kp7Thux_m"))
      this.topmenus = JSON.parse(decriptedStr);
    }
    return this.topmenus;
  }

  getScreenPermission(pagecode: string, Operation: string) {
    let IsHadPermission = false;
    let UserData = this.userService.getUserDetais()
    if (UserData != null && UserData != undefined) {
      UserData.FEATURES.forEach(element => {
        var isScreenExits = element.Features.filter(function (item) {
          return item.Code == pagecode;
        })[0];
        if (isScreenExits != undefined && isScreenExits != null) {
          if (isScreenExits.OperationMapped.indexOf(Operation) > -1) {
            IsHadPermission = true;
          }
        }
      });
    }
    return IsHadPermission;
  }

  getModuleId(module: string): string {
    let modid = "";
    switch (module) {
      case "ist":
        modid = "2";
        break;
      case "eap":
        modid = "4";
        break;
      case "grantscme":
      case "grants":
        modid = "4";
        break;
      case "grantssponsership":
        modid = "3";
        break;
      case "grantscharitable":
        modid = "7";
        break;
    }

    return modid;
  }

  getLocalOrgObject():any
  {
    let encriptedStr=this.securityService.decryptionAES(localStorage.getItem("G7k8VfmWzR_org"));
    return encriptedStr;
  }

  setOrganizations(orgs) {
    this.orgs = orgs;
    let encriptedStr=this.securityService.encryptionAES(JSON.stringify(orgs))
    localStorage.setItem("G7k8VfmWzR_org", encriptedStr);
  }

   setlocalStorageUserDetails(UserDetails:any){
    let encriptedStr=this.securityService.encryptionAES(UserDetails);
    localStorage.setItem("uds",encriptedStr);
   }
   getlocalStorageUserDetails(){
    return this.securityService.decryptionAES(localStorage.getItem("uds"));
   }

  getOrganizationName(code: string): string {debugger;
    let orgname = "";
    let orgId = "";

    if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(this.getLocalOrgObject());
    }
    if (this.orgs === null || this.orgs === undefined)
      return "";
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          orgname = this.orgs[i].NAME
          break;
        }
      }
      return orgname;
    }
  }

  getOrgDetails():any {
    return  JSON.parse(this.getLocalOrgObject());
   }
  getOrganizationObject(code: string): Organization {
    let org=null;

    //if (this.orgs === null || this.orgs === undefined) {
      this.orgs = JSON.parse(this.getLocalOrgObject());
   // }
    if (this.orgs === null || this.orgs === undefined)
      return null;
    else {
      const count = this.orgs.length;
      for (let i = 0; i < count; i++) {
        if (this.orgs[i].CODE.toLowerCase() === code.toLowerCase()) {
          org = this.orgs[i]
          break;
        }
      }
      return org;
    }
  }

 

  getStatus(statusnum: number): string {
    let status = "";
    return status;
  }

  getUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  ValidationBanner(Message: any) {
    const Modalref = this.modalService.open(MessageBoxComponent,
      { backdrop: false, }
    );
    Modalref.componentInstance.Content = { heading: 'Validation Message(s)', content: { heading: '', description: Message } };
  }
  InformationBanner(Message: any) {
    const modalref = this.modalService.open(MessageBoxComponent,
      { backdrop: false, }
    );
    modalref.componentInstance.Content = { heading: 'Information Message(s)', content: { heading: '', description: Message } };
    return modalref.result;
  }
  CanDeactivateBanner() {
    const modalRef = this.modalService.open(ConfirmationBoxComponent, {backdrop: false})
    modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'There are some unsaved details. Do you want to continue?', ProceedButtonName: "Ok", TerminateButtonName: "Cancel" };
    return modalRef.result;
  }
  SuccessBanner(Message: string) {
    const Modalref = this.modalService.open(SuccessBanertemplateComponent,
      {
        windowClass: 'sccsessMessage'
      });
    Modalref.componentInstance.Content = {
      message: Message
    };
  }
  ErrorBanner(Message: string) {
    const Modalref = this.modalService.open(ErrorbannerComponent,
      {
        windowClass: 'lg ErrorMessage',
        backdrop: false,
      });
    Modalref.componentInstance.Content = {
      message: Message
    };
  }

getdisplayedDate(date:string):Date
{
  if(date==null || date==undefined || date=="")
  {
    return null;
  }
  else{
    return new Date(date.replace('Z',''));
  }
}

  previewFile(fileid: string, filename: string, type: string) {
    let encodedFileName = btoa(filename);
    let expandEmailURL = serviceConstants.baseUrl + "/filepreview/" + fileid + "/" + type + "/" + encodedFileName
    window.open(`${expandEmailURL}`, 'Reference Document', 'width=800, height=500');
  }
  validateEmail(email: string): boolean {
    const regularExpression = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    //const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email));
  }

  refreshApplicationPage(applicationID: any, Moduleid: any, subModuleID: any) {
    switch (Moduleid) {
      case "ist":
        this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationID).subscribe(data => {
          this.istapp = data;
          this.appId = data.ID;
          this.setISTApp(this.istapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "IST";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.istapp.CurrentStatusExt;
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/ist/my-applications/application-ext/:' + data['ID'] + '/general_information_request'], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications" } })
        });
        break;
      case "eap":
        this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          this.eapapp = data;
          this.appId = data.ID;
          this.setEAPApp(this.eapapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "EAP";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.istapp.STATUS);
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/eap/my-applications/application-ext/:' + data['ID'] + '/program_info'], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications" } })
        });
        break;
      case "grants":
        let RecordID = "";
        this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          let modulecode = "";
          this.grantsapp = data;
          this.appId =this.grantsapp.ID;
          this.setGrantsApp(this.grantsapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = modulecode;
          this.menudata.operation = "Edit";
          this.menudata.appId = this.grantsapp.ID;
          if (this.grantsapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.grantsapp.STATUS);
       
          this.GrantsShare.setGrantApplicationID(applicationID);

          if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCME") {
            modulecode = "GRANTSCME";
            this.GrantsShare.CMEID.subscribe((x) => {
              RecordID = x;
              this.menudata.module = modulecode;
              this.removeLeftMenu();
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
          else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSSPONSORSHIP") {
            modulecode = "GRANTSSPONSORSHIP";
            this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }
          else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCHARITABLE") {
            modulecode = "GRANTSCHARITABLE";
            this.GrantsShare.CharityID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications" } })

            })
          }


        });
 
        break;
    }

  }

  ViewApplicationPage(applicationID: any, Moduleid: any, subModuleID: any) {
    switch (Moduleid) {
      case "ist":
        this.summaryService.getISTApplicationSummary("api/common/getistapp/" + applicationID).subscribe(data => {
          this.istapp = data;
          this.appId = data.ID;
          this.setISTApp(this.istapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "IST";
          this.menudata.operation = "Edit";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
         
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.istapp.CurrentStatusExt;
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/ist/my-applications/application-ext/:' + data['ID'] + '/general_information_request'], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "ist", submodule: "ist", screen_type: "my-applications",IsOnlyView:true } })
        });
        break;
      case "eap":
        this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          this.eapapp = data;
          this.appId = data.ID;
          this.setEAPApp(this.eapapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = "EAP";
          this.menudata.operation = "Edit";
          this.menudata.appId = this.istapp.ID;
          if (this.istapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.istapp.STATUS);
          this.setModluleMenu(this.menudata);

          this.header.setHeader(this.menudata);
          this.dataShare.setApplicationID(data["ID"]);
          this.router.navigate(['/home/eap/my-applications/application-ext/:' + data['ID'] + '/program_info'], { skipLocationChange: true, queryParams: { id: data['ID'], app_ext: true, module: "eap", submodule: "eap", screen_type: "my-applications",IsOnlyView:true } })
        });
        break;
      case "grants":
        let RecordID = "";
        this.summaryService.getISTApplicationSummary("api/common/getgrantsapp/" + applicationID).subscribe(data => {
          this.removeLeftMenu();
          let modulecode = "";
          this.grantsapp = data;
          this.appId =this.grantsapp.ID;
          this.setGrantsApp(this.grantsapp);
          this.menudata = new ModuleMenu();
          this.menudata.module = modulecode;
          this.menudata.operation = "Edit";
          this.menudata.appId = this.grantsapp.ID;
          if (this.grantsapp.STATUS === null)
            this.menudata.formstate = "Draft";
          else
            this.menudata.formstate = this.getStatus(this.grantsapp.STATUS);
       
          this.GrantsShare.setGrantApplicationID(applicationID);

          if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCME") {
            modulecode = "GRANTSCME";
            this.GrantsShare.CMEID.subscribe((x) => {
              RecordID = x;
              this.menudata.module = modulecode;
              this.removeLeftMenu();
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications",IsOnlyView:true } })

            })
          }
          else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSSPONSORSHIP") {
            modulecode = "GRANTSSPONSORSHIP";
            this.GrantsShare.SPONSORSHIPID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications",IsOnlyView:true } })

            })
          }
          else if (this.grantsapp.SubModuleNameExt.toLocaleString() === "GRANTSCHARITABLE") {
            modulecode = "GRANTSCHARITABLE";
            this.GrantsShare.CharityID.subscribe((x) => {
              RecordID = x;
              this.removeLeftMenu();
              this.menudata.module = modulecode;
              this.setModluleMenu(this.menudata);
              this.header.setHeader(this.menudata);
              this.router.navigate(['/home/grants/my-applications/application-ext/:' + applicationID + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants", submodule: modulecode, id: RecordID, app_ext: true, screen_type: "my-applications",IsOnlyView:true } })

            })
          }


        });
 
        break;
    }

  }
  
  getScreenStaticFields(screenCode: string,AppID: string) {
    return this.http.get(serviceConstants.apiURL + `api/screen/StaticControlsData?ScreenID=${screenCode}&AppID=${AppID}`, httpOptions);
  }
  public readonly keepAliveSession$ = timer(1000, 15 * 60 * 1000).pipe(
    tap(_ => console.trace("Session KeepAlive called for integrated services.")),
    switchMap(_ => this.http.get(serviceConstants.apiURL + 'api/Review/KeepAlive').pipe(retry(1)))
   );

   createDocEditorConfig(config: Partial<UserEditorConfig>): Observable<any> {
    return this.http.post<UserEditConfig>(serviceConstants.apiURL + 'api/Review/CreateDocEditorConfig', config, httpOptions);
   } 

   getRegistratinConfiguredFiledsData(id:string,module:string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + `api/RegistrationConfig/RegistrationControlsData?id=${id}&module=${module}`, httpOptions);
  }

  OnlyOfficePopupLanch(ReviewDocID,ReviwID, ReviewDocs: any = null, ApplicationCode: string = null):Observable<any>
   {
    const editorConfig: Partial<UserEditorConfig> = {
      CanEdit: false,
      CanReview: true,
      IsEditMode: false,
      FileID: ReviewDocID,
      ReviewID: ReviwID,
    };    
    return this.createDocEditorConfig(editorConfig).pipe(switchMap((x)=>this.OnlyOfficePopupLanchReturn(x,ReviewDocID,ReviwID,ApplicationCode,ReviewDocs)));
   }
   OnlyOfficePopupLanchReturn(result,ReviewDocID,ReviwID,ApplicationCode,ReviewDocs):Promise<any>
   {
        let options = {
          backdrop: false,
          windowClass: 'modal-xxl right modal-right',
        };
        if (result != null && result != undefined) {
          this.config = result;         
            const modalRef = this.modalService.open(OnlineEditorComponentimplements,options)       
          modalRef.componentInstance.config = result;
          if (result.OwnerID == result.UserID) {
            modalRef.componentInstance.editorType = EditorType.ReviewOwner;           
          } else {
            modalRef.componentInstance.editorType = EditorType.FreeEdit;
           // this.CompleteReviewDocStatus(this.config.UserConfigID,  ReviwID);
          }
          if (result.FileType == "docx" || result.FileType == "doc") {
            modalRef.componentInstance.formateType = "docx";
            modalRef.componentInstance.documentType = "word";
          } else {
            modalRef.componentInstance.formateType = "pptx";
            modalRef.componentInstance.documentType = "slide";
          }
          modalRef.componentInstance.Content = {
            ReviwID:ReviwID,
            FileID: ReviewDocID,
            ReviewDocs: ReviewDocs,
            ApplicationCode: ApplicationCode
          };
          return modalRef.result;
        }
    }
   
  
   CheckIsFileIsRefereancedInReviw(fileID: string) {
    return this.http.get(serviceConstants.apiURL + `api/common/CheckIsFileIsRefereancedInReviw?FileID=${fileID}`, httpOptions);
  }

  CompleteReviewDocStatus(url: any){   
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
    // return this.http.get("api/Review/ReviewDocUniqueKey?ConfigId=" +ConfigId + '&ReviewId=' + ReviewId,  httpOptions);
 }


 private stopDirty: BehaviorSubject<boolean> = new BehaviorSubject(false);
 makedirty = this.stopDirty.asObservable();
 getGlobalDirtyInfo():any {
   return this.stopDirty.asObservable();
   }

 setGlobalDirtyInfo(setdirty: boolean) {
   this.stopDirty.next(setdirty);
 }
}
